import {
  AssuredVerification,
  AssuredVerificationProps,
} from '@orcha/micro-library-widgets-ui';
import { useEffect, useState } from 'react';
import { VerifiedAppResponse } from 'src/pages/api/verify/app';
import { VerifiedSuggestionResponse } from 'src/pages/api/verify/suggestions';
import { useDebounce } from 'src/utilities/useDebounce';
import { logEventAnalytic } from 'src/utilities/logAnalytics';
import useSWR from 'swr';
import Image from 'next/image';
// import useSearchData from 'src/hooks/useSearchData';
import { Box } from '@mui/material';
import { IVerifiedSuggestion } from 'src/interfaces/verified';
import axios from 'axios';
// import AppCardListWidget from '../AppCardList';

const fetcher = (url: string) => fetch(url).then((res) => res.json());

const VerifiedWidget = (props: AssuredVerificationProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedAppId, setSelectedAppId] = useState<string | null>(null);
  const [appPrimaryCategory, setAppPrimaryCategory] = useState<string | null>(
    null
  );
  const debouncedSearch = useDebounce(searchTerm, 300);

  // const searchTermQueryString = `&SearchTerm=${encodeURIComponent(
  //   appPrimaryCategory ?? ''
  // )}`;

  // const { searchResults } = useSearchData(
  //   1,
  //   4,
  //   undefined,
  //   `${searchTermQueryString}`
  // );

  const onSearchChanged = (searchQuery: string) => {
    setSearchTerm(searchQuery);
  };

  const onOptionSelect = (option: string | IVerifiedSuggestion) => {
    if (typeof option === 'string') {
      return;
    }
    setSelectedAppId(option.id);
    setSearchTerm(option.appName);
  };

  const shouldGetApp = selectedAppId && selectedAppId.length > 2;

  const { data: foundApp } = useSWR<VerifiedAppResponse>(
    shouldGetApp ? `/api/verify/app?appId=${selectedAppId}` : null,
    fetcher
  );

  const shouldGetSuggestions =
    debouncedSearch && searchTerm && searchTerm?.length > 2;

  const { data: suggestionResponse } = useSWR<VerifiedSuggestionResponse>(
    shouldGetSuggestions
      ? `/api/verify/suggestions?searchTerm=${encodeURIComponent(
          debouncedSearch
        )}`
      : null,
    fetcher
  );

  const suggestions = suggestionResponse?.appSuggestions ?? [];

  if (foundApp?.app && foundApp.app.assured) {
    foundApp.app.assured.expiryDate = new Date(foundApp.app.assured.expiryDate);
  }
  // const filteredApps = searchResults?.apps?.filter(
  //   (app) => app.appId !== selectedAppId
  // );

  if (shouldGetSuggestions && (!suggestions || suggestions?.length === 0)) {
    suggestions?.push({ id: '0', appName: 'No results found' });
  }

  useEffect(() => {
    setAppPrimaryCategory(foundApp?.app?.categories[0] ?? null);
  }, [foundApp?.app, appPrimaryCategory]);

  const onAddToWatchlist = async (
    email: string,
    appId: string
  ): Promise<boolean> => {
    try {
      const response = await axios.post('/api/verify/watchlist', {
        notifyMeUrl: props.notifyMeUrl,
        email,
        appId,
        appName: foundApp?.app?.appName,
      });
      return response?.data?.success;
    } catch (error) {
      return false;
    }
  };

  return (
    <Box sx={{ margin: '1rem' }}>
      <AssuredVerification
        {...props}
        app={foundApp?.app}
        searchTerm={searchTerm}
        onSearchChanged={onSearchChanged}
        onOptionSelect={onOptionSelect}
        appSuggestions={suggestions}
        isLoading={!suggestions && shouldGetSuggestions}
        onAddToWatchlist={onAddToWatchlist}
        logEventAnalyticCallback={logEventAnalytic}
        avatarImage={
          <Image
            src={foundApp?.app?.appLogo ?? ''}
            alt={foundApp?.app?.appName ?? ''}
            width={40}
            height={40}
            quality={50}
            priority
          />
        }
        allTranslatedText={{
          subscribeAndCompare: {
            button: 'Subscribe To Compare',
          },
          buyReport: {
            button: 'Buy Report',
          },
          addToWatchList: {
            title: 'Add to Watchlist',
            button: 'Notify me',
          },
        }}
      />
      {/* {foundApp?.app && ( // As per Khuram’s request, I’m commenting this out until we can refactor the suggestions functionality.
        <AppCardListWidget
          title="You might also like"
          apps={filteredApps}
          appCardLimit={3}
        />
      )} */}
    </Box>
  );
};

export default VerifiedWidget;
